<app-page-header header="" backgroundPath="assets/images/lead/lead-news.jpg"></app-page-header>
<div class="container" style="padding-top: 30px;">

  <section class="section-select -menu visible-sm visible-xs show-on-min">
    <app-dropdown [title]="titleDropdown" [valueDropdown]="valueDropdown" (selected)="selectValue($event)">
    </app-dropdown>
  </section>

  <ul class="nav nav-tabs tab-four show-on-max" id="myTab" role="tablist">
    <li class="nav-item">
      <a class="nav-link {{choiceFromSelect==='option1'? 'active': ''}}" id="one-tab" data-toggle="tab" href="#one"
        [routerLink]="['/compliance-index-manager','option1']" role="tab" aria-controls="one"
        aria-selected="true">{{language.imsmenu1}}</a>
    </li>
    <li class="nav-item">
      <a class="nav-link {{choiceFromSelect==='option2'? 'active': ''}}" id="two-tab" data-toggle="tab" href="#two"
        [routerLink]="['/compliance-index-manager','option2']" role="tab" aria-controls="two"
        aria-selected="false">{{language.imsmenu2}}</a>
    </li>
    <li class="nav-item">
      <a class="nav-link {{choiceFromSelect==='option3'? 'active': ''}}" id="three-tab" data-toggle="tab" href="#three"
        [routerLink]="['/compliance-index-manager','option3']" role="tab" aria-controls="three"
        aria-selected="false">{{language.imsmenu3}}</a>
    </li>
    <li class="nav-item">
      <a class="nav-link {{choiceFromSelect==='option4'? 'active': ''}}" id="four-tab" data-toggle="tab" href="#four"
        [routerLink]="['/compliance-index-manager','option4']" role="tab" aria-controls="four"
        aria-selected="false">{{language.imsmenu4}}</a>
    </li>
    <li class="nav-item">
      <a class="nav-link {{choiceFromSelect==='option5'? 'active': ''}}" id="five-tab" data-toggle="tab" href="#five"
        [routerLink]="['/compliance-index-manager','option5']" role="tab" aria-controls="five"
        aria-selected="false">{{language.imsmenu5}}</a>
    </li>
    <li class="nav-item">
      <a class="nav-link {{choiceFromSelect==='option6'? 'active': ''}}" id="six-tab" data-toggle="tab" href="#six"
        [routerLink]="['/compliance-index-manager','option6']" role="tab" aria-controls="six"
        aria-selected="false">{{language.imsmenu6}}</a>
    </li>
  </ul>

  <div class="tab-content" id="myTabContent">
    <div [ngSwitch]="choiceFromSelect">

      <div *ngSwitchCase="'option1'" class="tab-pane fade show active" id="one" role="tabpanel"
        aria-labelledby="one-tab">

        <section class="announce-detail" style="padding-top: 30px;">
          <ul class="list-announce row">
            <li data-mh="desc-announce" *ngFor="let item of renderAnnounce"
              class="col-12 offset-0 offset-sm-3 offset-lg-0 col-lg-6">
              <div *ngIf="flag == 'th'; else elseoption1">
                <span class="date">{{date_thai_dd(item.publicDate)}}</span>
                <span class="month-year">{{date_thai_mm(item.publicDate)}}<br>{{date_thai_yy(item.publicDate)}}</span>
                <a [routerLink]="['/th/manager/detail',item.managerListid]" class="visible-touch">
                  <p>{{item.title}} </p>
                </a>
              </div>
              <ng-template #elseoption1>
                <span class="date">{{item.publicDate | date:'dd'}}</span>
                <span class="month-year">{{item.publicDate | date:'MMMM'}}<br>{{item.publicDate | date:'yyyy'}}</span>
                <a [routerLink]="['/th/manager/detail',item.managerListid]" class="visible-touch">
                  <p>{{item.title_en}} </p>
                </a>
              </ng-template>
            </li>
          </ul>
        </section>

        <footer class="text-center" style="padding-top: 40px">
          <app-paginator [currentPage]="newsCurrentPage_announce" [totalPage]="totalNewsPage_announce"
            (currentPageNumber)="setCurrentNewsPage_announce($event)"></app-paginator>
        </footer>

      </div>
      <div *ngSwitchCase="'option2'" class="tab-pane fade  show active" id="two" role="tabpanel"
        aria-labelledby="two-tab">

        <section class="announce-detail" style="padding-top: 30px;">
          <ul class="list-announce row">
            <li data-mh="desc-announce" *ngFor="let item of renderAnnounce"
              class="col-12 offset-0 offset-sm-3 offset-lg-0 col-lg-6">
              <div *ngIf="flag == 'th'; else elseoption2">
                <span class="date">{{date_thai_dd(item.publicDate)}}</span>
                <span class="month-year">{{date_thai_mm(item.publicDate)}}<br>{{date_thai_yy(item.publicDate)}}</span>
                <a [routerLink]="['/th/transaction/detail',item.transactionid]" class="visible-touch">
                  <p>{{item.title}} </p>
                </a>
              </div>
              <ng-template #elseoption2>
                <span class="date">{{item.publicDate | date:'dd'}}</span>
                <span class="month-year">{{item.publicDate | date:'MMMM'}}<br>{{item.publicDate | date:'yyyy'}}</span>
                <a [routerLink]="['/th/transaction/detail',item.transactionid]" class="visible-touch">
                  <p>{{item.title_en}} </p>
                </a>
              </ng-template>
            </li>
          </ul>
        </section>

        <footer class="text-center" style="padding-top: 40px">
          <app-paginator [currentPage]="newsCurrentPage_announce" [totalPage]="totalNewsPage_announce"
            (currentPageNumber)="setCurrentNewsPage_announce($event)"></app-paginator>
        </footer>

      </div>
      <div *ngSwitchCase="'option3'" class="tab-pane fade  show active" id="three" role="tabpanel"
        aria-labelledby="three-tab">

        <section class="announce-detail" style="padding-top: 30px;">
          <ul class="list-announce row">
            <li data-mh="desc-announce" *ngFor="let item of renderAnnounce"
              class="col-12 offset-0 offset-sm-3 offset-lg-0 col-lg-6">
              <div *ngIf="flag == 'th'; else elseoption3">
                <span class="date">{{date_thai_dd(item.publicDate)}}</span>
                <span class="month-year">{{date_thai_mm(item.publicDate)}}<br>{{date_thai_yy(item.publicDate)}}</span>
                <a [routerLink]="['/th/guideline/detail',item.guidelineid]" class="visible-touch">
                  <p>{{item.title}} </p>
                </a>
              </div>
              <ng-template #elseoption3>
                <span class="date">{{item.publicDate | date:'dd'}}</span>
                <span class="month-year">{{item.publicDate | date:'MMMM'}}<br>{{item.publicDate | date:'yyyy'}}</span>
                <a [routerLink]="['/th/guideline/detail',item.guidelineid]" class="visible-touch">
                  <p>{{item.title_en}} </p>
                </a>
              </ng-template>
            </li>
          </ul>
        </section>

        <footer class="text-center" style="padding-top: 40px">
          <app-paginator [currentPage]="newsCurrentPage_announce" [totalPage]="totalNewsPage_announce"
            (currentPageNumber)="setCurrentNewsPage_announce($event)"></app-paginator>
        </footer>

      </div>
      <div *ngSwitchCase="'option4'" class="tab-pane fade  show active" id="four" role="tabpanel"
        aria-labelledby="four-tab">

        <section class="announce-detail" style="padding-top: 30px;">
          <ul class="list-announce row">
            <li data-mh="desc-announce" *ngFor="let item of renderAnnounce"
              class="col-12 offset-0 offset-sm-3 offset-lg-0 col-lg-6">
              <div *ngIf="flag == 'th'; else elsevoteList">
                <span class="date">{{date_thai_dd(item.publicDate)}}</span>
                <span class="month-year">{{date_thai_mm(item.publicDate)}}<br>{{date_thai_yy(item.publicDate)}}</span>
                <a [routerLink]="['/th/vote/detail',item.voteid]" class="visible-touch">
                  <p>{{item.title}} </p>
                </a>
              </div>
              <ng-template #elsevoteList>
                <span class="date">{{item.publicDate | date:'dd'}}</span>
                <span class="month-year">{{item.publicDate | date:'MMMM'}}<br>{{item.publicDate | date:'yyyy'}}</span>
                <a [routerLink]="['/th/vote/detail',item.voteid]" class="visible-touch">
                  <p>{{item.title_en}} </p>
                </a>
              </ng-template>
            </li>
          </ul>
        </section>

        <footer class="text-center" style="padding-top: 40px">
          <app-paginator [currentPage]="newsCurrentPage_announce" [totalPage]="totalNewsPage_announce"
            (currentPageNumber)="setCurrentNewsPage_announce($event)"></app-paginator>
        </footer>

      </div>
      <div *ngSwitchCase="'option5'" class="tab-pane fade  show active" id="five" role="tabpanel"
        aria-labelledby="five-tab">

        <section class="announce-detail" style="padding-top: 30px;">
          <ul class="list-announce">
            <li data-mh="desc-announce" *ngFor="let item of renderAnnounce"
              class="col-12 offset-0 offset-sm-3 offset-lg-0 col-lg-6">
              <div *ngIf="flag == 'th'; else elseoption5">
                <span class="date">{{date_thai_dd(item.publicDate)}}</span>
                <span class="month-year">{{date_thai_mm(item.publicDate)}}<br>{{date_thai_yy(item.publicDate)}}</span>
                <a [routerLink]="['/th/holding/detail',item.holdingInvestUnitid]" class="visible-touch">
                  <p>{{item.title}} </p>
                </a>
              </div>
              <ng-template #elseoption5>
                <span class="date">{{item.publicDate | date:'dd'}}</span>
                <span class="month-year">{{item.publicDate | date:'MMMM'}}<br>{{item.publicDate | date:'yyyy'}}</span>
                <a [routerLink]="['/th/holding/detail',item.holdingInvestUnitid]" class="visible-touch">
                  <p>{{item.title_en}} </p>
                </a>
              </ng-template>
            </li>
          </ul>
        </section>

        <footer class="text-center" style="padding-top: 40px">
          <app-paginator [currentPage]="newsCurrentPage_announce" [totalPage]="totalNewsPage_announce"
            (currentPageNumber)="setCurrentNewsPage_announce($event)"></app-paginator>
        </footer>

      </div>

      <div *ngSwitchCase="'option6'" class="tab-pane fade  show active" id="six" role="tabpanel" aria-labelledby="six-tab">
      
        <section class="announce-detail" style="padding-top: 30px;">
          <ul class="list-announce">
            <li data-mh="desc-announce" *ngFor="let item of renderAnnounce"
              class="col-12 offset-0 offset-sm-3 offset-lg-0 col-lg-6">
              <div *ngIf="flag == 'th'; else elseoption6">
                <span class="date">{{date_thai_dd(item.publicDate)}}</span>
                <span class="month-year">{{date_thai_mm(item.publicDate)}}<br>{{date_thai_yy(item.publicDate)}}</span>
                <a [routerLink]="['/th/assigned/detail',item.id]" class="visible-touch">
                  <p>{{item.title}} </p>
                </a>
              </div>
              <ng-template #elseoption6>
                <span class="date">{{item.publicDate | date:'dd'}}</span>
                <span class="month-year">{{item.publicDate | date:'MMMM'}}<br>{{item.publicDate | date:'yyyy'}}</span>
                <a [routerLink]="['/th/assigned/detail',item.id]" class="visible-touch">
                  <p>{{item.title_en}} </p>
                </a>
              </ng-template>
            </li>
          </ul>
        </section>
      
        <footer class="text-center" style="padding-top: 40px">
          <app-paginator [currentPage]="newsCurrentPage_announce" [totalPage]="totalNewsPage_announce"
            (currentPageNumber)="setCurrentNewsPage_announce($event)"></app-paginator>
        </footer>
      
      </div>
    </div>
  </div>
</div>